import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import ProjectSocial from '@/components/ProjectSocial'
import ProjectBrilliantMind from '@/components/ProjectBrilliantMind'
import ProjectMercedes from '@/components/ProjectMercedes'
import ProjectNykart from '@/components/ProjectNykart'
import ProjectPizzaBox from '@/components/ProjectPizzaBox'
import ProjectJanczaki from '@/components/ProjectJanczaki'
import ProjectMatthias from '@/components/ProjectMatthias'
import ProjectStreetwear from '@/components/ProjectStreetwear'
import ProjectSocialMonsterNew from '@/components/ProjectSocialMonsterNew'
import _404 from '@/components/inner-components/_404'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: HomePage,
      activeSection: 0
    },
    {
      path: '/project-social',
      name: 'ProjectSocial',
      component: ProjectSocial
    },
    {
      path: '/project-brilliant-mind',
      name: 'ProjectBrilliantMind',
      component: ProjectBrilliantMind
    },
    {
      path: '/project-mercedes',
      name: 'ProjectMercedes',
      component: ProjectMercedes
    },
    {
      path: '/project-nykart',
      name: 'ProjectNykart',
      component: ProjectNykart
    },
    {
      path: '/project-pizzabox',
      name: 'ProjectPizzaBox',
      component: ProjectPizzaBox
    },
    {
      path: '/project-janczaki',
      name: 'ProjectJanczaki',
      component: ProjectJanczaki
    },
    {
      path: '/project-matthias',
      name: 'ProjectMatthias',
      component: ProjectMatthias
    },
    {
      path: '/project-streetwear',
      name: 'ProjectStreetwear',
      component: ProjectStreetwear
    },
    {
      path: '/project-social-monster-new',
      name: 'ProjectSocialMonsterNew',
      component: ProjectSocialMonsterNew
    },
    {
      path: "*",
      name: '404',
      component: _404
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js